import { AuthenticationResult } from '@azure/msal-browser';
import { createLanguagePathname } from 'utils/pathFactory';
import { authenticateNipClient, setAcceptLanguage as setNipAcceptLanguage } from './nip';
import { authenticatePpClient, setAcceptLanguage as setPpAcceptLangauge } from './pp';
import { config } from './config';
import { loadDefaultMessages, loadRequestedMessages, parseLanguage } from './translation';
import * as ga from './ga';

export * from './config';
export * from './msal';

export async function bootstrapApplication() {
  // all boot operation should goes here.
  setClientsAcceptLanguage();
  ga.init();
  await Promise.all([loadDefaultMessages(), loadRequestedMessages()]);
}

export function authenticateClients(auth: AuthenticationResult) {
  authenticatePpClient(auth);
  authenticateNipClient(auth);
}

export function unauthenticateClients() {
  authenticatePpClient(null);
  authenticateNipClient(null);
}

export function setClientsAcceptLanguage() {
  const language = parseLanguage();

  setPpAcceptLangauge(language);
  setNipAcceptLanguage(language);
}

export function getLanguagePathname(lang: string): string {
  return createLanguagePathname(parseLanguage(), lang, config.publicUrl);
}
